import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-image-box',
  templateUrl: './image-box.component.html',
  styleUrls: ['./image-box.component.scss']
})
export class ImageBoxComponent {
  isDragging = false;
  startX = 0;
  startY = 0;
  currentX = 0;
  currentY = 0;
  rotationAngle: number = 0;
  //zoom = 1;
  maxZoom = 3;
  minZoom = 1;

  @Input() blobImage!: string;
  @Input() filenameText!: string;
  @Input() isBigImage = false;
  @Input() isImageCollapsed = false;
  @Input() zoom = 1;
  @Input() temAnterior = false;
  @Input() doShortcutActive: boolean = true;
  @Input() uid: string = '';

  @Output() voltar = new EventEmitter<void>();
  @Output() anterior = new EventEmitter<void>();
  @Output() toggleCollapsedImage = new EventEmitter<void>();

  @ViewChild('imageContainer', { static: true }) imageContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('image') image!: ElementRef;

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.startX = event.clientX - this.currentX;
    this.startY = event.clientY - this.currentY;
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.endDrag);
  }

  onDrag = (event: MouseEvent) => {
    event.preventDefault();
    if (!this.isDragging) return;

    this.currentX = event.clientX - this.startX;
    this.currentY = event.clientY - this.startY;

    const imageEl = this.image.nativeElement;
    const containerEl = this.imageContainer.nativeElement;
    const maxY = imageEl.clientHeight - 50;
    const minY = 0 - imageEl.clientHeight + 50;
    const maxX = imageEl.clientWidth - 50;
    const minX = 0 - imageEl.clientWidth + 50;

    if(this.currentX > maxX){
      this.currentX = maxX;
    }
    if(this.currentX < minX){
      this.currentX = minX;
    }
    if(this.currentY > maxY){
      this.currentY = maxY;
    }
    if(this.currentY < minY){
      this.currentY = minY;
    }
    //imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;
    imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px) rotate(${this.rotationAngle}deg)`;
  };

  endDrag = () => {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.endDrag);
  };

  resetZoom() {
    this.zoom = 1;
    this.imageContainer.nativeElement.style.transform = `scale(${this.zoom})`;
    this.currentX = 0;
    this.currentY = 0;
    const imageEl = this.image.nativeElement;
    imageEl.style.transform = `translate(0px, 0px)`;
  }

  zoomIn() {
    if (this.zoom < this.maxZoom) {
      this.zoom += 0.1;
    }
  } 
  zoomOut() {
    if (this.zoom > this.minZoom) {
      this.zoom -= 0.1;
    }else{
      const imageEl = this.image.nativeElement;
      imageEl.style.transform = `translate(0px, 0px)`;
    }
  }

  rotateImage() {
    const imageEl = this.image.nativeElement;
    this.rotationAngle = (this.rotationAngle + 90) % 360;
    imageEl.style.transform = `rotate(${this.rotationAngle}deg)`;
  }
  
  
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!event.altKey) return;
      event.preventDefault();
      switch (event.key) {
        case '+': this.zoomIn(); break;
        case '=': this.zoomIn(); break;
        case '-': this.zoomOut(); break;
        case '_': this.zoomOut(); break;
        case 'R': case 'r': this.rotateImage(); break;
        case 'ArrowUp': event.preventDefault();this.triggerButton('ArrowUp'); break;
        case 'ArrowDown': event.preventDefault();this.triggerButton('ArrowDown'); break;
        case 'ArrowLeft': event.preventDefault();this.triggerButton('ArrowLeft'); break;
        case 'ArrowRight': event.preventDefault();this.triggerButton('ArrowRight'); break;
        case 'I': case 'i': this.abrirImagemBase64(); break;
      }
  }
  
  triggerButton(buttonId: string) {
    const imageEl = this.image.nativeElement;
    
    switch (buttonId) {
      case 'ArrowUp':
        this.currentY -= 10;
        break;
      case 'ArrowDown':
        this.currentY += 10;
        break;
      case 'ArrowLeft':
        this.currentX -= 10;
        break;
      case 'ArrowRight':
        this.currentX += 10;
        break;
    }
    imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px) rotate(${this.rotationAngle}deg)`;
  }

  abrirImagemBase64() {
    localStorage.setItem('prescriptionId', this.uid);
    window.open('/image', '_blank', 'width=800,height=600,noopener,noreferrer');
  }
}
